import { AppCard, AppCardContent, AppCardMedia } from '@app/components/base/app-card';
import { EnrichedCompositionListItemDto } from '@app/modules/compose/composition.types';
import { FragmentCardCreator } from '@app/modules/fragments/screens/list/fragment-card/base/FragmentCardCreator';
import { FragmentCardRelativeTime } from '@app/modules/fragments/screens/list/fragment-card/base/FragmentCardRelativeTime';
import { fragmentGridCardContentSx } from '@app/modules/fragments/screens/list/fragment-card/base/styles';
import { FRAGMENT_CARD_PADDING_X } from '@app/modules/fragments/screens/list/fragment-card/constants';
import { Box, Typography } from '@mui/material';
import { composeRouteGenerator } from '../../../routing/compose-route-generator';
import { CompositionCardEditsCount } from './CompositionCardEditsCount';
import { CompositionCardMedia } from './CompositionCardMedia';

const footerSx = {
  px: FRAGMENT_CARD_PADDING_X,
  pb: 1.5,
  pt: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flexWrap: 'nowrap',
} as const;

/** Creator + time: shrinks first and wraps internally so the edits chip stays on the row. */
const footerMetaSx = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  columnGap: 0.5,
  rowGap: 0.25,
  '& > *': {
    minWidth: 0,
    overflowWrap: 'break-word',
  },
} as const;

/**
 * List card for a composition: navigates to composition detail (Editions).
 */
export function CompositionCard({ composition }: { composition: EnrichedCompositionListItemDto }) {
  return (
    <AppCard
      to={{
        pathname: composeRouteGenerator.view(composition.id),
        state: { composition },
      }}
      media={
        <AppCardMedia>
          <CompositionCardMedia composition={composition} />
        </AppCardMedia>
      }
      footer={
        <Box sx={footerSx}>
          <Box sx={footerMetaSx}>
            <FragmentCardCreator creator={composition.creator} />
            <FragmentCardRelativeTime createdAt={composition.createdAt} />
          </Box>
          <CompositionCardEditsCount count={composition.edits.length} />
        </Box>
      }
    >
      <AppCardContent sx={fragmentGridCardContentSx}>
        <Typography variant="subtitle1" component="h3">
          {composition.name}
        </Typography>
      </AppCardContent>
    </AppCard>
  );
}
